import { Injectable } from '@angular/core';

export interface FontCatalogEntry {
    family: string;
    category: string;
    googleFontsUrl: string;
}

@Injectable({ providedIn: 'root' })
export class FontLoaderService {
    private loadedFonts = new Set<string>();

    private static readonly ALLOWED_FONT_ORIGINS = [
        'https://fonts.googleapis.com/',
        'https://fonts.gstatic.com/',
    ];

    async loadFont(family: string, googleFontsUrl: string): Promise<void> {
        if (this.loadedFonts.has(family)) return;
        if (!FontLoaderService.ALLOWED_FONT_ORIGINS.some(o => googleFontsUrl.startsWith(o))) {
            console.warn(`[FontLoader] Blocked untrusted font URL: ${googleFontsUrl}`);
            return;
        }
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = googleFontsUrl;
        document.head.appendChild(link);
        try {
            await document.fonts.load(`16px "${family}"`);
        } catch {
            // Font may still render via the injected stylesheet
        }
        this.loadedFonts.add(family);
    }

    async loadFonts(entries: Array<{ family: string; googleFontsUrl: string }>): Promise<void> {
        await Promise.all(entries.map(e => this.loadFont(e.family, e.googleFontsUrl)));
    }

    isLoaded(family: string): boolean {
        return this.loadedFonts.has(family);
    }
}
